import React from 'react';
import { NewCard } from './new-card';

export const PaymentMainGuest = () => <NewCard />;
